import { Link } from "react-router-dom";
import { Logo } from "./SiteNav";
import { INDUSTRIES } from "@/data/industries";
import { CONTACT_EMAIL } from "@/data/site";

export function SiteFooter() {
  return (
    <footer className="border-t border-[#1E2D4A] bg-[#060A15]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2 space-y-4">
          <Logo small />
          <p className="text-sm text-slate-400 max-w-sm">Completions and commissioning management linked to your programme. Built in the UK.</p>
          <p className="text-sm text-slate-400">Contact: <span className="text-slate-200" data-testid="footer-contact-email">{CONTACT_EMAIL}</span></p>
          <p className="text-sm text-slate-400">Sister product: <a href="https://p6pulse.com" target="_blank" rel="noreferrer" className="text-amber-400 hover:underline">P6 Pulse</a></p>
        </div>
        <div>
          <p className="eyebrow mb-4">Industries</p>
          <ul className="space-y-2 text-sm">
            {INDUSTRIES.map((i) => <li key={i.slug}><Link to={`/industries/${i.slug}`} className="text-slate-400 hover:text-white">{i.name}</Link></li>)}
          </ul>
        </div>
        <div>
          <p className="eyebrow mb-4">Company</p>
          <ul className="space-y-2 text-sm">
            <li><a href="/#pricing" className="text-slate-400 hover:text-white">Pricing</a></li>
            <li><a href="/#faq" className="text-slate-400 hover:text-white">FAQ</a></li>
            <li><Link to="/sales" data-testid="footer-sales-link" className="text-slate-400 hover:text-white">Sales material</Link></li>
            <li><Link to="/manual" data-testid="footer-manual-link" className="text-slate-400 hover:text-white">System manual (customers)</Link></li>
            <li><a href="/#demo" className="text-slate-400 hover:text-white">Request a demo</a></li>
            <li><Link to="/login" className="text-slate-400 hover:text-white">Sign in</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy-link" className="text-slate-400 hover:text-white">Privacy policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#1E2D4A] py-5 text-center text-xs text-slate-500 font-mono">© {new Date().getFullYear()} Pulse Commissioning. All prices exclude VAT.</div>
    </footer>
  );
}
